export default __webpack_public_path__ + "static/media/May2018.5185eac5.png";